import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentChargesRepository } from '../infra/ShipmentChargesRepository'

export type GetShipmentChargesFactoryDependencies = {
  repository: ShipmentChargesRepository
}

export function getShipmentChargesFactory({ repository }: GetShipmentChargesFactoryDependencies) {
  return function getShipmentCharges(uuid: string, config?: { signal?: AbortSignal }) {
    return repository.getShipmentCharges(uuid, config)
  }
}

export function getShipmentCharges(uuid: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const get = getShipmentChargesFactory({ repository })

  return get(uuid, config)
}
